import React from 'react'
import { Job, JobWizardMobile } from 'sprockets_react/job_wizards/registries'
import $ from 'sprockets_react/job_wizards/jquery'

JobWizardMobile.SelectCategory = {
  onSubmit: function(onStepProgression, onRequest, onRequestCompletion) {
    let details = this

    if (Job.Data.referrer.cta !== 'profile') {
      JobWizardMobile.StepSequence.removeStepByType(JobWizardMobile.MatchedBusiness)
    }

    details.selectExactMatchForSubcategory(() => {
      if (Job.Data.backToSubmit === true){
        JobWizardMobile.Emitter.emit('job:wizard:advanceToStep', JobWizardMobile.JobSummary)
      }
      else {
        onStepProgression()
      }
    })
  },

  buttonLayout: function() {
    return 'downButton'
  },

  searchTerm() {
    return $('input[name="category"]').val()
  },

  selectExactMatchForSubcategory(callback) {
    $.ajax(SS.API.V3.subCategoriesGet({ 'filter[q]': this.searchTerm(), 'filter[prefer_keywords]': '1' })).done((response) => {
      const keyword = response.meta.keyword

      if (keyword) {
        let category = { id: keyword.subcategoryID, value: keyword.subcategoryName }
        Job.Actions.updateCategory(category)
        Job.Actions.updateSubCategory(category, 'add')
        Job.Actions.updateKeyword(keyword.value)
      } else {
        for (let item of response.data) {
          if (this.searchTerm().toLowerCase() == item.attributes.name.toLowerCase()) {
            let category = { id: parseInt(item.id, 10), value: item.attributes.name }
            Job.Actions.updateCategory(category)
            Job.Actions.updateSubCategory(category, 'add')
          }
        }
      }
      callback()
    })
  },

  component: React.createClass({
    getInitialState: function() {
      return { showCategoryInput: true }
    },

    componentDidMount: function() {
      Job.Actions.resetCategories()
      JobWizardMobile.Emitter.addListener('job:wizard:hideCategoryInput', this.updateState)
    },

    componentWillUnmount: function() {
      JobWizardMobile.Emitter.removeListener('job:wizard:hideCategoryInput', this.updateState)
    },

    updateState: function(data) {
      this.setState(data)
    },

    render: function() {
      return (
        <div className="form-horizontal">
          <div className={`${this.state.showCategoryInput ? '' : 'hidden'}`}>
            <div className="form-group mb24">
              <div className="col-xs-12 details-mobile">
                <h3 className="mt10">Who or what do you need?</h3>
                <div className="font-14 text-copy-0 pb5">e.g Tiler, Cleaner, Electrician</div>
                <div className="input-group p5 border radius-6">
                  <JobWizardMobile.Category />
                  <span className="input-group-btn">
                    <JobWizardMobile.NavigationButtons
                      navButtonLayout='okButton'
                      onStepProgression={this.props.onStepProgression}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}
